import { render, staticRenderFns } from "./PriceOfMedicineDropdown.vue?vue&type=template&id=55bf8891&scoped=true&"
import script from "./PriceOfMedicineDropdown.vue?vue&type=script&lang=ts&"
export * from "./PriceOfMedicineDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./PriceOfMedicineDropdown.vue?vue&type=style&index=0&id=55bf8891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf8891",
  null
  
)

export default component.exports